<template> 
  <div>
    <v-row>
        <v-flex>
            <v-text-field v-model="fechaDesdeFormatted" :label="labelDesde" type="date" prepend-icon="event"
                                @input="desdeChanged"></v-text-field>
        </v-flex>

        <v-flex>
            <v-text-field v-model="fechaHastaFormatted" :label="labelHasta" type="date" prepend-icon="event"
                                @input="hastaChanged"></v-text-field>
        </v-flex>
    </v-row>
  </div>
</template>

<script>

import Vue from 'vue'
import { split,subDays,startOfMonth,startOfYear, endOfMonth, format } from 'date-fns'


export default {
  data: () => ({
        fechaDesdeFormatted: format(new Date(), 'YYYY-MM-DD'),
        fechaHastaFormatted: format(new Date(), 'YYYY-MM-DD')
  }),
  props: {
    Label: String  
  },
  created() {
    this.desdeChanged(this.fechaDesdeFormatted);
    this.hastaChanged(this.fechaHastaFormatted);    
  },
  computed:{
    labelDesde: function(){
      if(this.Label){
        return this.Label + ' Desde';
      }
      return "Desde";
    },
    labelHasta: function(){
      if(this.Label){
        return this.Label + ' Hasta';
      }
      return "Hasta";
    }
  },
  methods: {
    desdeChanged(newDate){
        this.$emit('desde-changed', this.fechaDesdeFormatted);
    },
    hastaChanged(newDate){
        this.$emit('hasta-changed', this.fechaHastaFormatted);
    }
  }
}
</script>
